const finance = "/assets/UIUX/finance.webp";
const healthcare = "/assets/UIUX/healthcare.webp";
const ecommerce = "/assets/UIUX/ecommerce.webp";
const logistics = "/assets/UIUX/logistics.webp";
const edulearn = "/assets/UIUX/edulearn.webp";
const crm = "/assets/UIUX/crm.webp";

const CardData = [
  {
    icon: "/assets/UIUX/img1.svg",
    iconStyles: "w-[87px] h-[81px]",
    heading: "User Research ",
    paragraph:
      "We begin by listening, to your users, to your data, and to the problem you’re solving. Through real conversations, behavior insights, and a touch of empathy, we uncover what your users truly need.",
  },
  {
    icon: "/assets/UIUX/img2.svg",
    iconStyles: "w-[72px] h-[67px]",
    heading: "Wireframing",
    paragraph:
      "Before we dive into visuals, we sketch out structure. Wireframes help us map the journey, what happens, when, and why making sure everything flows exactly how your users expect. Think of it as the blueprint for a better user experience.",
  },
  {
    icon: "/assets/UIUX/img3.svg",
    iconStyles: "w-[60px] h-[78px]",
    heading: "Visual Designing",
    paragraph:
      "Here’s where the magic happens. Our designers blend art and logic to bring your brand to life, clean layouts, modern aesthetics, and pixel-perfect details that connect and convert.",
  },
];

const ImageCardData = [
  {
    image: finance,
    topic: "FinanceTracker Pro",
    text: "Complete financial management platform",
    frameworks: "React + Node.js",
  },
  {
    image: healthcare,
    topic: "HealthCare Portal",
    text: "Patient management system for clinics",
    frameworks: "Flutter",
  },
  {
    image: ecommerce,
    topic: "E-Commerce Suite",
    text: "Full-featured online shopping platform",
    frameworks: "React + Node.js",
  },
  {
    image: logistics,
    topic: "LogisticsPro",
    text: "Supply chain management solution",
    frameworks: "React + Node.js",
  },
  {
    image: edulearn,
    topic: "EduLearn Platform",
    text: "Online learning management system",
    frameworks: "React + Node.js",
  },
  {
    image: crm,
    topic: "CRM Dashboard",
    text: "Customer relationship management tool",
    frameworks: "React + Node.js",
  },
];

const points = [
  { content1: "We listen. Really listen." },
  { content1: "Our designs speak your brand’s language." },
  { content1: "We mix creativity with data form with function." },
  { content1: "You’re part of the process, every step of the way." },
];

const ProcessData = [
  {
    topic: "Discovery & Research",
    description:
      "We kick off with curiosity, learning about your users, your product, and your goals. No assumptions.",
  },
  {
    topic: "Wireframing",
    description:
      "We sketch and plan every page and interaction, giving you a clear view of the product’s skeleton before diving into the skin.",
  },
  {
    topic: "Visual Design",
    description:
      "Now comes the glow-up. We craft visually appealing interfaces that align with your brand and excite your users.",
  },
  {
    topic: "Prototype & Test",
    description:
      "Click, scroll, interact. We turn designs into clickable prototypes and test them with real users to fine-tune the experience.",
  },
  {
    topic: "Delivery & Handoff",
    description:
      "Once everything feels right, we package the final designs with clean documentation - ready for your dev team to bring it to life.",
  },
  {
    topic: "Post-launch Feedback",
    description:
      "We don’t disappear after delivery. We gather real user feedback post-launch and help refine the experience even further.",
  },
];

export { CardData, ImageCardData, points, ProcessData };
